export const backEs = {
  status: {
    open: 'Abierto',
    new: 'Nuevo',
    closed: 'Cerrado',
    pending: 'Pendiente',
    finished: 'Terminado',
  },
  states: {
    true: 'Activo',
    false: 'Inactivo',
  },
  sport: {
    soccer: 'Fútbol',
    basket: 'Baloncesto',
    csgo: 'CS:GO',
    lol: 'League of Legends'
  },
  role: {
     df: 'Defensa',
     gk: 'Portero',
     mf: 'Centrocampista',
     fw: 'Delantero',
     top: 'Top',
     mid: 'Middle',
     bot: 'Bottom',
     jun: 'Jungle',
     sup: 'Support',
     pl: 'Player',
  },
};
